<template>
  <article
    class="group relative overflow-hidden w-[350px] h-[520px] rounded-2xl bg-white shadow-lg transition-all hover:shadow-xl hover:-translate-y-1 flex flex-col"
  >
    <!-- Image Section -->
    <div class="relative w-full h-[220px] overflow-hidden rounded-t-2xl">
      <img
        :src="image"
        :alt="title"
        class="object-cover w-full h-full"
      />
      <!-- Category and Price Overlay -->
      <div class="absolute top-4 left-4 right-4 flex items-start justify-between">
        <div class="text-xs font-semibold uppercase tracking-[0.3em] text-gray-400 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
          {{ category }}
        </div>
        <div class="rounded-full bg-gray-100/95 backdrop-blur-sm px-4 py-1.5 text-xs font-semibold text-gray-900">
          {{ formatPrice(price) }} <span class="text-gray-500 font-normal">/ {{ per }}</span>
        </div>
      </div>
    </div>

    <!-- Content Section -->
    <div class="flex-1 flex flex-col justify-between p-6 bg-white">
      <div class="space-y-3 flex-1 overflow-y-auto">
        <div>
          <p class="text-xs uppercase tracking-[0.3em] text-gray-400 mb-1">Umrah Experience</p>
          <h3 class="text-2xl font-bold text-gray-900">
            {{ title }}
          </h3>
          <p class="text-gray-600 text-sm mt-2">
            {{ nights }} • {{ cities }}
          </p>
        </div>
        <ul class="space-y-2 text-sm text-gray-700 mt-4">
          <li
            v-for="(hotel, index) in hotels"
            :key="`hotel-${index}`"
            class="flex items-start space-x-2"
          >
            <span class="h-[1px] w-6 bg-amber-400 mt-2 flex-shrink-0" />
            <span class="text-gray-600">{{ hotel }}</span>
          </li>
        </ul>
      </div>

      <!-- Button Section -->
      <div class="mt-6 flex items-center justify-between pt-4 border-t border-gray-200">
        <a
          :href="whatsappUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center space-x-2 rounded-full bg-amber-500 px-5 py-2.5 text-sm font-semibold uppercase tracking-wide text-white transition hover:bg-amber-600"
        >
          <span>Book Now</span>
          <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M13 5l7 7-7 7" />
          </svg>
        </a>
        <div class="text-right text-xs uppercase tracking-[0.3em] text-gray-400">
          Flexible Dates
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { formatPrice } from '../services/currencyStore'

export default {
  name: 'PackageCard',
  props: {
    title: {
      type: String,
      required: true
    },
    category: {
      type: String,
      default: 'Outdoors'
    },
    price: {
      type: Number,
      required: true
    },
    per: {
      type: String,
      default: 'person'
    },
    nights: {
      type: String,
      required: true
    },
    cities: {
      type: String,
      required: true
    },
    hotels: {
      type: Array,
      default: () => []
    },
    image: {
      type: String,
      required: true
    },
    whatsappNumber: {
      type: String,
      required: true
    }
  },
  computed: {
    whatsappUrl() {
      const message = `I want to book the *${this.title}* package`
      const encodedMessage = encodeURIComponent(message)
      const cleanNumber = this.whatsappNumber.replace(/[^0-9]/g, '')
      return `https://wa.me/${cleanNumber}?text=${encodedMessage}`
    }
  },
  methods: {
    formatPrice
  }
}
</script>

